// Human-friendly timestamps: "just now", "18 minutes ago", "Yesterday at 4:12 PM".

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;

const timeFmt = new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit' });
const weekdayFmt = new Intl.DateTimeFormat('en-US', { weekday: 'long' });
const dateFmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
const dateYearFmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
const fullFmt = new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'short' });
const monthYearFmt = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' });

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

export function relativeTime(iso: string, now: Date = new Date()): string {
  const then = new Date(iso);
  const diff = now.getTime() - then.getTime();

  if (diff < MINUTE) return 'just now';
  if (diff < HOUR) {
    const m = Math.floor(diff / MINUTE);
    return `${m} minute${m === 1 ? '' : 's'} ago`;
  }
  if (diff < 12 * HOUR) {
    const h = Math.floor(diff / HOUR);
    return `${h} hour${h === 1 ? '' : 's'} ago`;
  }

  const days = Math.round((startOfDay(now) - startOfDay(then)) / (24 * HOUR));
  if (days === 0) return `Today at ${timeFmt.format(then)}`;
  if (days === 1) return `Yesterday at ${timeFmt.format(then)}`;
  if (days < 7) return weekdayFmt.format(then);
  if (then.getFullYear() === now.getFullYear()) return dateFmt.format(then);
  return dateYearFmt.format(then);
}

export function fullTime(iso: string): string {
  return fullFmt.format(new Date(iso));
}

export function monthYear(iso: string): string {
  return monthYearFmt.format(new Date(iso));
}

export function shortDate(iso: string): string {
  return dateYearFmt.format(new Date(iso));
}

/** Greeting for the board header, by local hour. */
export function greeting(now: Date = new Date()): string {
  const h = now.getHours();
  if (h < 5) return 'Good evening';
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
}
